import './Avatar.scss';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Avatar extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        imageUrl: PropTypes.string,
        size: PropTypes.oneOf(['large', 'medium', 'small'])
    };

    render() {
        let { className, imageUrl, size, ...otherProps } = this.props;

        return (
            <figure
                className={classNames('c-avatar', className, {'a-avatar--has-image': imageUrl != null && imageUrl !== '', 'a-avatar--large': size === 'large', 'a-avatar--medium': size === 'medium', 'a-avatar--small': size === 'small'})}
                style={imageUrl != null && imageUrl !== '' ? {backgroundImage: `url(${imageUrl})`} : null}
                {...otherProps}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Avatar/index.js